import React, {useState} from 'react';
import { Button } from 'react-bootstrap';

interface NavigationButtonProps {
    label: string;
    iconPath: string;
    isActive: boolean;
    onClick: () => void;
}

const NavigationButton = ({
                              label,
                              iconPath,
                              isActive,
                              onClick
                          }: NavigationButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Button
            variant="link"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                color: '#fff',
                textDecoration: 'none',
                backgroundColor: isActive
                    ? '#4798bb'
                    : isHovered
                        ? 'rgba(255, 255, 255, 0.15)'
                        : 'transparent',
                width: '210px',
                textAlign: 'left',
                padding: '10px 16px',
                display: 'flex',
                alignItems: 'center',
                border: 'none',
                transition: 'background-color 0.3s ease',
            }}
        >
            <img
                src={iconPath}
                alt=""
                style={{
                    height: '26px',
                    marginRight: '14px',
                }}
            /> {label}
        </Button>
    );
};

export default NavigationButton;
